/*
 * @Author: Lim 
 * @Date: 2020-09-04 15:17:20 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-17 16:55:43
 */
import React, {  } from 'react';
import style from "./Button.module.scss";
import cn from 'classnames';
import { initConfig, unitFilter } from '../common';

export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        type: 'blue',
        text: '未知文本',
        loading: false,
        disable: false,
        height: 28,
        fontSize: 12,
        margin: '0',
        customCss: {},
        warn: false, 
        check(){},
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     * css
     */
    const { 
        type,
        text, 
        loading, 
        disable, 
        height, 
        fontSize, 
        margin, 
        warn, 
        customCss,
        check
    } = initConfig( defaultConfig, props.config );

    const defaultHeight = unitFilter ( height );
    const defaultFontSize = unitFilter ( fontSize );
    const buttonDefaultCss = { height: defaultHeight, boxSizing: 'border-box', fontSize: defaultFontSize }
    const buttonCss = type === 'custom' ? Object.assign( buttonDefaultCss , customCss ) : buttonDefaultCss; 
    /**
     * Func
     * 点击按钮
     */
    const _btnClick = () => {
        if(disable === true || loading === true) return false;
        check();
    }
    /**
     * DOM
     */
    return (
        <div 
            className={ style.btn }
            style={{ margin:margin, height: defaultHeight, boxSizing: 'border-box', fontSize: defaultFontSize}}
        >
            <div className={ cn(
                disable === false ? "" :style.disable
            ) }></div>
            <div 
                className={cn(
                    style.button_box,
                    type === 'white' ? style.white_btn : type === 'custom' ? style.custom_btn : style.blue_btn,
                    warn === true ? style.warn : "",
                    loading !== false ? style.has_loading : "",
                    disable !== false ? style.has_disable : ""
                ) }
                style={ buttonCss }
                onClick = { ()=> _btnClick() }
            >
                {
                    type === 'custom' ? 
                    <div className={ style.masking }></div>
                    : ""

                }
                { 
                    loading === true ? 
                    <div className={ style.loading }><div className={ style.load }></div>
                    </div>
                    : ""
                }
                <span 
                    className={ cn(
                            loading === true ? style.text_hidden : "",
                            style.btn_text 
                        )
                    }
                >{ text }</span>
            </div>
        </div>
    )
}